import { DeviceReadyStoryContent } from '../contexts/device-ready-story/device-ready-story.type';
import { Version } from '../contexts/device-ready-story/parser/DeviceReadyStoryParser.type';

import { User } from './users';

export enum StoryStatus {
  draft = 'DRAFT',
  rejected = 'REJECTED',
  published = 'PUBLISHED',
  submitted = 'SUBMITTED',
}

export enum DRSPackageStatus {
  failed = 'FAILED',
  inProgress = 'IN_PROGRESS',
  succeeded = 'SUCCEEDED',
}

export interface DeviceReadyStory {
  id: string;
  storyId?: string;
  accountId: string;
  originalBasicStoryId: string;
  title: string;
  backgroundImage: { url: string; previewUrl: string };
  status: StoryStatus;
  tags: string[];
  backgroundAudio: {
    isPlayingAllowed?: boolean;
    url?: string;
    desiredVolumeLevel?: number;
  };
  storyLanguage: string;
  content: DeviceReadyStoryContent[];
  createdAt: Date;
  updatedAt: Date;
  contentVersion?: Version;
  creator: User;
  description?: string;
  drsPackage: null | {
    status: DRSPackageStatus;
    buildError?: string;
  };
  version?: number;
}

export interface SimpleStory {
  storyId: string;
  accountId: string;
  title: string;
  imageObjects: { previewUrl: string; url: string }[];
  drsPackages: {
    status: DRSPackageStatus;
  };
  status: StoryStatus;
  tags: string[];
  content: string;
  summary: string;
  creator: User;
  createdAt: Date;
  updatedAt: Date | null;
  denialReason?: string;
  isBookmarked?: boolean;
  minimumAge?: number;
}

export type Tag = {
  id: string;
  title: string;
};

export enum CreateDeviceReadyStoryContentControls {
  text = 'text',
  audio = 'audio',
  audioRecording = 'audioRecording',
  attachment = 'attachment',
  routines = 'routines',
}
